export const adminCardWrapperSx = {
  width: '100%',
  maxWidth: '560px',
  margin: '0 auto',
};

export const adminCardSx = {
  width: '100%',
  border: (theme) => `1px solid ${theme.palette.whiteScale.main}`,
  boxShadow: 'none',
  borderRadius: '12px',
};

export const adminScrollbarSx = {
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(0,0,0,0.15) transparent',
  '&::-webkit-scrollbar': { width: '4px' },
  '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,0.15)', borderRadius: '999px' },
  '&::-webkit-scrollbar-thumb:hover': { backgroundColor: 'rgba(0,0,0,0.3)' },
};

export const adminListScrollSx = {
  minHeight: '360px',
  maxHeight: 'min(80vh, 900px)',
  overflow: 'auto',
  backgroundColor: '#FFFFFF',
  ...adminScrollbarSx,
};

export const adminSearchActionRowSx = {
  justifyContent: 'space-between',
  gap: 1,
  mt: 1.25,
  pt: 0.75,
  pb: 1.5,
};
